/**
 * Component map — maps componentName to lazy-loaded Vue component.
 *
 * Separated from indicatorRegistry.js so that the registry remains
 * pure data (testable without Webpack/Vue).
 */

export const componentMap = {
  // ── Quantitativos ─────────────────────────────────────────────────────
  EquipmentBySectorChart: () =>
    import('../components/GenerateReport/components/charts/quantitative/equipmentBySector.vue'),
  AlienatedEquip: () =>
    import('../components/GenerateReport/components/charts/quantitative/alienatedEquip.vue'),
  RequestBySector: () =>
    import('../components/GenerateReport/components/charts/quantitative/requestBySector.vue'),
  StoppedEquipPendingType: () =>
    import('../components/GenerateReport/components/charts/quantitative/stoppedEquipPendingType.vue'),
  TopFiveEquipFailures: () =>
    import('../components/GenerateReport/components/charts/quantitative/topFiveEquipFailures.vue'),
  DefectSolutionPrev: () =>
    import('../components/GenerateReport/components/charts/quantitative/defectSolutionPrev.vue'),
  SolicitedVConcluded: () =>
    import('../components/GenerateReport/components/charts/quantitative/solicitedVConcluded.vue'),
  CorrectiveScheXExec: () =>
    import('../components/GenerateReport/components/charts/quantitative/correctiveSchedXExec.vue'),
  InternalResolvability: () =>
    import('../components/GenerateReport/components/charts/quantitative/internalResolvability.vue'),
  PreventiveXCorrective: () =>
    import('../components/GenerateReport/components/charts/quantitative/preventiveXCorrective.vue'),
  PreventiveSchedXExec: () =>
    import('../components/GenerateReport/components/charts/quantitative/preventiveSchedxExec.vue'),
  CalibSchedXExec: () =>
    import('../components/GenerateReport/components/charts/quantitative/calibSchedXExec.vue'),
  EletricSecSchedXExec: () =>
    import('../components/GenerateReport/components/charts/quantitative/eletricSecSchedXExec.vue'),
  ValidationQualificationSchedXExec: () =>
    import('../components/GenerateReport/components/charts/quantitative/validationQualificationSchedXExec.vue'),
  ScheduledMaintenance: () =>
    import('../components/GenerateReport/components/charts/quantitative/scheduledMaintenance.vue'),
  HistoricalMigration: () =>
    import('../components/GenerateReport/components/charts/quantitative/historicalMigration.vue'),
  OrderByWorkshop: () =>
    import('../components/GenerateReport/components/charts/quantitative/orderByWorkshop.vue'),
  ResponsibleServicesByWeek: () =>
    import('../components/GenerateReport/components/charts/quantitative/responsibleServicesByWeek.vue'),
  RequestsPerCostCenter: () =>
    import('../components/GenerateReport/components/charts/quantitative/requestsPerCostCenter.vue'),
  InappropriateUseEquipment: () =>
    import('../components/GenerateReport/components/charts/quantitative/inappropriateUseEquipment.vue'),

  RecurringCalls: () =>
    import('../components/GenerateReport/components/charts/quantitative/recurringCalls.vue'),
  InspectionSchedXExec: () =>
    import('../components/GenerateReport/components/charts/quantitative/inspectionSchedXExec.vue'),
  PendingOsByType: () =>
    import('../components/GenerateReport/components/charts/quantitative/pendingOsByType.vue'),

  // ── Tempos ────────────────────────────────────────────────────────────
  StoppedMachine: () =>
    import('../components/GenerateReport/components/charts/time/stoppedMachine.vue'),
  StandEquipFailures: () =>
    import('../components/GenerateReport/components/charts/time/standEquipFailures.vue'),
  TotalServiceTime: () =>
    import('../components/GenerateReport/components/charts/time/totalServiceTime.vue'),
  ServiceForecast: () =>
    import('../components/GenerateReport/components/charts/control/serviceForecast.vue'),
  CallsAnsweredChart: () =>
    import('../components/GenerateReport/components/charts/control/CallsAnsweredChart.vue'),
  ResolutionForecast: () =>
    import('../components/GenerateReport/components/charts/control/resolutionForecast.vue'),
  CallsResolvedChart: () =>
    import('../components/GenerateReport/components/charts/control/CallsResolvedChart.vue'),
  ServiceTimeDepartment: () =>
    import('../components/GenerateReport/components/charts/time/serviceTimeDepartment.vue'),
  ServiceTimeCrit: () =>
    import('../components/GenerateReport/components/charts/time/serviceTimeCrit.vue'),
  ProdTime: () =>
    import('../components/GenerateReport/components/charts/time/prodTime.vue'),
  ProdTimeSector: () =>
    import('../components/GenerateReport/components/charts/time/prodTimeSector.vue'),
  ResolutionTimeCrit: () =>
    import('../components/GenerateReport/components/charts/time/resolutionTimeCrit.vue'),
  TotalResolutionTimeCrit: () =>
    import('../components/GenerateReport/components/charts/time/totalResolutionTimeCrit.vue'),
  ServiceOrdersTimeSteps: () =>
    import('../components/GenerateReport/components/charts/time/serviceOrdersTimeSteps.vue'),
  DisplacementTime: () =>
    import('../components/GenerateReport/components/charts/time/displacementTime.vue'),
  ProdTimeOrderType: () =>
    import('../components/GenerateReport/components/charts/time/prodTimeOrderType.vue'),

  // ── Custos ────────────────────────────────────────────────────────────
  CostPerPiece: () =>
    import('../components/GenerateReport/components/charts/costs/costPerPiece.vue'),
  CostPerService: () =>
    import('../components/GenerateReport/components/charts/costs/costPerService.vue'),
  CostPerSector: () =>
    import('../components/GenerateReport/components/charts/costs/costPerSector.vue'),
  CostPerId: () =>
    import('../components/GenerateReport/components/charts/costs/costPerId.vue'),
  LogisticCost: () =>
    import('../components/GenerateReport/components/charts/costs/costPerLogistic.vue'),
  AvoidedCosts: () =>
    import('../components/GenerateReport/components/charts/costs/avoidedCosts.vue'),
  InternalLaborCost: () =>
    import('../components/GenerateReport/components/charts/costs/internalLaborCost.vue'),

  // ── Controle de Qualidade ─────────────────────────────────────────────
  OrderRatings: () =>
    import('../components/GenerateReport/components/charts/control/orderRatings.vue'),
  RankingSupplier: () =>
    import('../components/GenerateReport/components/charts/control/rankingSupplier.vue'),
  AdhesionCalledMod: () =>
    import('../components/GenerateReport/components/charts/control/adhesionCalledMod.vue'),
}
